import type { AssetResponse } from '@on3/api';
import { ResizedImage } from 'components/Image/ResizedImage';

import styles from './JoinFansiteMarketing.module.scss';

interface IJoinFansiteMarketingProps {
  title?: string | null;
  description?: string | null;
  asset?: AssetResponse;
}
export const JoinFansiteMarketing = ({
  title,
  description,
  asset,
}: IJoinFansiteMarketingProps) => {
  return (
    <section className={styles.siteMarketingSection}>
      <h2>{title}</h2>

      {asset?.source && (
        <ResizedImage
          {...asset}
          fit="cover"
          gravity="0.5x0.5"
          quality={90}
          width={1040}
        />
      )}
      {description && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </section>
  );
};
